<script setup lang="ts">
import type { GalleryItem } from "~/composables/usePostImages";

defineEmits<{
  shareImage: [item?: GalleryItem];
  likeImage: [item?: GalleryItem];
  zoomImage: [item?: GalleryItem];
}>();

const props = withDefaults(
  defineProps<{
    images?: GalleryItem[];
  }>(),
  { images: () => [] }
);

const images = ref(props.images);
onMounted(() => {
  nextTick(() => {
    images.value = [...props.images];
  });
});
</script>

<template>
  <section class="post-images">
    <div class="post-images__container lg:container">
      <div class="post-images__wrapper">
        <div class="post-images__header px-5 lg:px-0 mb-8 lg:mb-10">
          <h2
            class="post-images__title text-[1.75rem] leading-[1.5rem] lg:text-[3.125rem] lg:leading-[2.75rem]"
          >
            <span class="inline">Wszystkie</span>
            <span class="inline tracking-[0.25rem]">&emsp14;</span>
            <span class="inline font-display tracking-[0.3125rem]"
              >zdjęcia</span
            >
          </h2>
        </div>

        <div class="post-images__content">
          <div class="post-grid__wrapper grid lg:grid-cols-4 gap-10">
            <template v-for="item in images">
              <ContentImage
                v-if="item && (item as GalleryItem).collection === 'images'"
                provider="directus"
                :src="(item as GalleryItem).item?.file?.id + ((item as GalleryItem).item?.file?.filename_download ? '/' + encodeURIComponent(item.item.file!.filename_download!) : '')"
                :width="(item as GalleryItem).item?.file?.width"
                :height="(item as GalleryItem).item?.file?.height"
                :alt="(item as GalleryItem).item?.file?.description || (item as GalleryItem).item?.caption || 'Zdjęcie'"
                :caption="(item as GalleryItem).item?.caption"
                :image-id="(item as GalleryItem).item?.id"
                @share="() => $emit('shareImage', item as GalleryItem)"
                @like="() => $emit('likeImage', item as GalleryItem)"
                @zoom="() => $emit('zoomImage', item as GalleryItem)"
                sizes="290px xs:353px sm:576px md:692px lg:226px xl:310px xxl:430px"
              />

              <ContentVideo
                v-else-if="item && (item as GalleryItem).collection === 'videos'"
                provider="directus"
                :src="(item as GalleryItem).item?.file?.id + ((item as GalleryItem).item?.file?.filename_download ? '/' + encodeURIComponent(item.item.file!.filename_download!) : '')"
                :width="(item as GalleryItem).item?.file?.width"
                :height="(item as GalleryItem).item?.file?.height"
                :caption="(item as GalleryItem).item?.caption"
                :type="(item as GalleryItem).item?.file?.type"
                :poster="(item as GalleryItem).item?.poster?.id"
                @zoom="() => $emit('zoomImage', item as GalleryItem)"
                mini
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
